import { render, staticRenderFns } from "./AdminCompetitionCard.vue?vue&type=template&id=9b15a358&"
import script from "./AdminCompetitionCard.vue?vue&type=script&lang=js&"
export * from "./AdminCompetitionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports